import { render, staticRenderFns } from "./lb-table.vue?vue&type=template&id=7dd80208"
import script from "./lb-table.vue?vue&type=script&lang=js"
export * from "./lb-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports